module.exports = __webpack_public_path__ + "img/45.ce238c92.jpg";